import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PropertyFeatureTemplateService } from '../property-feature-template.service';
import { PropertyFeatureTemplate } from '../property-feature-template';
import { PropertyFeatureTemplateComponent } from '../property-feature-template/property-feature-template.component';

@Component({
    selector: 'app-property-feature-template-list',
    templateUrl: './property-feature-template-list.component.html',
    styleUrls: ['./property-feature-template-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PropertyFeatureTemplateListComponent implements OnInit {
	constructor(
		private propertyFeatureTemplateService: PropertyFeatureTemplateService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = propertyFeatureTemplateService.statuses
	}



	// data
	propertyFeatureTemplates: any;
	propertyFeatureTemplate: PropertyFeatureTemplate;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'propertyFeatureTemplateId', header: 'Id', width: 'auto' },
		{ field: 'templateName', header: 'Template Name', width: 'auto' },
		{ field: 'locationId', header: 'LocationId', width: 'auto' },
		{ field: 'adrDistrict', header: 'Adr District', width: 'auto' },
		{ field: 'adrCity', header: 'Adr City', width: 'auto' },
		{ field: 'adrRegion', header: 'Adr Region', width: 'auto' },
		{ field: 'developmentId', header: 'DevelopmentId', width: 'auto' },
		{ field: 'bedrooms', header: 'Bedrooms', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.propertyFeatureTemplateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-propertyFeatureTemplate-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyFeatureTemplateService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.propertyFeatureTemplates = res.data.propertyFeatureTemplates;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.propertyFeatureTemplates = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(propertyFeatureTemplate: PropertyFeatureTemplate) {
		try {
			this.formLoading = true;
			this.propertyFeatureTemplateService.update(propertyFeatureTemplate)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.propertyFeatureTemplates.map((propertyFeatureTemplate, i) => {
							if (propertyFeatureTemplate.propertyFeatureTemplateId === res.data.propertyFeatureTemplate.propertyFeatureTemplateId) {
								this.propertyFeatureTemplates[i] = res.data.propertyFeatureTemplate;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(propertyFeatureTemplate: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(propertyFeatureTemplate));

			this.formLoading = true;
			this.propertyFeatureTemplateService.delete(propertyFeatureTemplate.propertyFeatureTemplateId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.propertyFeatureTemplates.splice(this.propertyFeatureTemplates.indexOf(propertyFeatureTemplate), 1);
						this.recordTotal = this.propertyFeatureTemplates.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'PropertyFeatureTemplate ' + propertyFeatureTemplate.propertyFeatureTemplateId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'PropertyFeatureTemplate ' + propertyFeatureTemplate.propertyFeatureTemplateId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add PropertyFeatureTemplate'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyFeatureTemplateComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPropertyFeatureTemplateCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(propertyFeatureTemplate: PropertyFeatureTemplate) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			propertyFeatureTemplate: propertyFeatureTemplate,
			title: 'Edit PropertyFeatureTemplate'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyFeatureTemplateComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePropertyFeatureTemplateCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePropertyFeatureTemplateCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPropertyFeatureTemplateCB(propertyFeatureTemplate: PropertyFeatureTemplate) {
		console.log('Adding PropertyFeatureTemplate: ' + JSON.stringify(propertyFeatureTemplate));
		// if we don't have a propertyFeatureTemplates array yet...
		if (!this.propertyFeatureTemplates) {
			this.propertyFeatureTemplates = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.propertyFeatureTemplates.unshift(propertyFeatureTemplate);

		// no idea what this is but it is required to update the array
		this.propertyFeatureTemplates = [...this.propertyFeatureTemplates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyFeatureTemplate ' + propertyFeatureTemplate.propertyFeatureTemplateId + ' Added', life: 3000 });
	}

	updatePropertyFeatureTemplateCB(propertyFeatureTemplate: PropertyFeatureTemplate) {
		console.log('Updating PropertyFeatureTemplate: ' + JSON.stringify(propertyFeatureTemplate));
		let itemIndex = this.propertyFeatureTemplates.findIndex((item: any) => item.propertyFeatureTemplateId === propertyFeatureTemplate.propertyFeatureTemplateId);
		this.propertyFeatureTemplates[itemIndex] = propertyFeatureTemplate;

		// no idea what this is but it is required to update the array
		this.propertyFeatureTemplates = [...this.propertyFeatureTemplates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyFeatureTemplate ' + propertyFeatureTemplate.propertyFeatureTemplateId + ' Updated', life: 3000 });
	}

	deletePropertyFeatureTemplateCB(propertyFeatureTemplate: PropertyFeatureTemplate) {
		console.log('Removing PropertyFeatureTemplate: ' + propertyFeatureTemplate);
		this.propertyFeatureTemplates.splice(this.propertyFeatureTemplates.indexOf(propertyFeatureTemplate), 1);
		this.recordTotal = this.propertyFeatureTemplates.length;

		// no idea what this is but it is required to update the array
		this.propertyFeatureTemplates = [...this.propertyFeatureTemplates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyFeatureTemplate ' + propertyFeatureTemplate.propertyFeatureTemplateId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.propertyFeatureTemplates ? this.first === (this.propertyFeatureTemplates.length - this.rows) : true; }
	isFirstPage(): boolean { return this.propertyFeatureTemplates ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(propertyFeatureTemplate: any) {
		if (propertyFeatureTemplate?.status) {
			const status = this.statuses.find((e: any) => e.value == propertyFeatureTemplate.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
	
	
}
